import { render, staticRenderFns } from "./myvip.vue?vue&type=template&id=7c59f0fc&scoped=true&"
import script from "./myvip.vue?vue&type=script&lang=js&"
export * from "./myvip.vue?vue&type=script&lang=js&"
import style0 from "./myvip.vue?vue&type=style&index=0&id=7c59f0fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59f0fc",
  null
  
)

export default component.exports